import { useState } from "react";
import { Download, FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const CsvButton = ({ authFetch, path, label = "Download CSV", testId, title, excel = false }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const r = await authFetch(path);
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Download failed");
      const name = /filename="([^"]+)"/.exec(r.headers.get("content-disposition") || "")?.[1] || "positivelife.csv";
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement("a");
      a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 30000);
      toast.success(`${name} downloaded`);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testId} onClick={run} disabled={busy} title={title} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-3 py-1.5 text-xs hover:bg-muted transition-colors disabled:opacity-60">
      {busy ? <Loader2 size={12} className="animate-spin" /> : excel ? <FileSpreadsheet size={12} className="text-[#1D6F42]" /> : <Download size={12} />} {label}
    </button>
  );
};
